import ReactGA from "react-ga4";
import TagManager from "react-gtm-module";

// Send event data to Google Analytics
export const sendEventGA = (eventName, eventParams) => {
  window.gtag("event", eventName, {
    ...eventParams,
  });
};

// Send event data to Google Tag Manager
export const sendEventGTM = (eventName, eventParams) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...eventParams,
  });
};

export const SetDefaultConsentMode = () => {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag("js", new Date());

  ReactGA.gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    functionality_storage: "denied",
    personalization_storage: "denied",
    security_storage: "denied",
  });
};

export const UpdateConsentModeRejectAll = () => {
  ReactGA.gtag("consent", "update", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    functionality_storage: "denied",
    personalization_storage: "denied",
    security_storage: "denied",
  });
};

export const UpdateConsentModeAcceptAll = () => {
  ReactGA.gtag("consent", "update", {
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
    analytics_storage: "granted",
    functionality_storage: "granted",
    personalization_storage: "granted",
    security_storage: "granted",
  });
};

export const consentGrantedAnalyticsStorage = () => {
  ReactGA.gtag("consent", "update", {
    // need analytics_storage and ad_user_data to be granted for GA4 to work
    analytics_storage: "granted",
    // ad_storage: "granted",
    // ad_personalization: "granted",
    ad_user_data: "granted",
  });
};

export const InitializeGA = (region) => {
  if (region === "EU") {
    ReactGA.initialize("G-MKNCBGGVZ9");
  } else if (region === "FR") {
    ReactGA.initialize("G-NW9V8FSKQQ");
  } else {
    ReactGA.initialize("G-VW1E9MCH3Z");
  }
};

export const InitializeGTM = (region) => {
  if (region === "EU") {
    const tagManagerArgs = {
      gtmId: "GTM-5MNJ2XFJ",
    };
    TagManager.initialize(tagManagerArgs);
  } else if (region === "FR") {
    const tagManagerArgs = {
      gtmId: "GTM-KLVFZSL9",
    };
    TagManager.initialize(tagManagerArgs);
  } else {
    const tagManagerArgs = {
      gtmId: "GTM-MXWD38J8",
    };
    TagManager.initialize(tagManagerArgs);
  }
};

export const sendStudyLinkClick = (title, url) => {
  sendEventGTM("study-link-click", {
    title: title,
    url: url,
  });
};

export const sendWatchEventLinkClick = (title, url) => {
  sendEventGTM("watch-event-link-click", {
    title: title,
    url: url,
  });
};
